var ProductTypeEnum = /* @__PURE__ */ ((ProductTypeEnum2) => {
  ProductTypeEnum2["SIMPLE_PRODUCT"] = "SimpleProduct";
  ProductTypeEnum2["CONFIGURABLE_PRODUCT"] = "ConfigurableProduct";
  ProductTypeEnum2["BUNDLE_PRODUCT"] = "BundleProduct";
  ProductTypeEnum2["GROUPED_PRODUCT"] = "GroupedProduct";
  return ProductTypeEnum2;
})(ProductTypeEnum || {});
export {
  ProductTypeEnum
};
